import styled from "styled-components/macro";
import { Heading3, Heading4 } from "styles/elements/Headings";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleTitle = styled(Heading3)<Props>`
margin-top: 52px;
`;

export const CollapsibleContainer = styled.div<Props>`
  width: 100%;
  > div:first-child {
    background-color: white;
  }
`;

export const TeacherOverviewContainer = styled.div<Props>`
  padding: 0 100px;
  margin-bottom: 20px;
`;

export const MaterialHeader = styled(Heading4)<Props>`
  margin-bottom: 10px;
  width: 100%;
`;
